var _linearGradient, _linearGradient2, _linearGradient3, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixfiFullLogoLightPathsMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg10938",
    viewBox: "0 0 180 90",
    height: "90mm",
    width: "180mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs10935"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1876"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop1872"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#920092",
      stopOpacity: 0.07936508
    },
    offset: 1,
    id: "stop1874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1870"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop1866"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#920092",
      stopOpacity: 0.08333334
    },
    offset: 1,
    id: "stop1868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1858"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop1854"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#920092",
      stopOpacity: 0.11111112
    },
    offset: 1,
    id: "stop1856"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient1876",
    id: "linearGradient1860",
    x1: 84.583,
    y1: 25.206,
    x2: 129.481,
    y2: 25.206,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.0255 0 0 -.07218 -21.94 27.908)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient1858",
    id: "linearGradient1862",
    x1: 68.148,
    y1: 44.992,
    x2: 129.763,
    y2: 44.992,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.80622 0 0 .5459 6.108 9.883)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient1870",
    id: "linearGradient1864",
    x1: 78.19,
    y1: 53.199,
    x2: 129.034,
    y2: 53.199,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.96476 0 0 .73557 -14.497 4.264)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style4"
  }, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@1,300;1,400;1,700;1,900=swap);")), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "url(#linearGradient1862)",
      strokeWidth: ".179707px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: ".0898538,.0898538",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m61.098 42.617 49.579-16.344",
    id: "path1162"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "url(#linearGradient1864)",
      strokeWidth: ".222887px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: ".111443,.111443",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m61.023 60.353 48.88-33.914",
    id: "path1164"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "url(#linearGradient1860)",
      strokeWidth: 0.17,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: ".085,.085",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m64.828 26.446 45.986-.714",
    id: "path1166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0,
      stroke: "#000",
      strokeWidth: 0.666001,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path9089",
    d: "m165.647 148.564-151.957-.886L90.436 16.522z",
    transform: "rotate(-83.5 46.984 14.169) scale(.22414)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0,
      stroke: "#000",
      strokeWidth: 0.666001,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path9089-9",
    d: "M120.537 86.067 90.368 139.86 58.867 86.837z",
    transform: "rotate(-83.5 46.647 14.656) scale(.2281)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m53.075 43.556 1.585 5.98",
    id: "path9307"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".100147px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m58.614 34.03 6.161-7.732",
    id: "path9323"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m49.272 34.89-6.141 4.059",
    id: "path9329"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0899526px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m42.487 39.315-8.93.153",
    id: "path9331"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m55.176 50.698 6.068 9.348",
    id: "path9341"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m53.776 40.171 4.04-5.123",
    id: "path9345"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m43.22 39.453 7.48 1.787",
    id: "path9355"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m58.425 35.151 2.552 7.4",
    id: "path9411"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".0884892px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m54.23 49.913-5.842-2.401",
    id: "path9413"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0997578,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-2-5",
    cx: 67.361,
    cy: -7.876,
    r: 1.288,
    transform: "rotate(51.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.0498788,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-8-6-1",
    cx: -73.384,
    cy: 11.683,
    r: 0.644,
    transform: "rotate(-128.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.0498788,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-8-1",
    cx: -8.867,
    cy: -57.274,
    r: 0.644,
    transform: "rotate(141.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.0498788,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-1-7-5",
    cx: 24.057,
    cy: 63.273,
    r: 0.644,
    transform: "rotate(-38.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0748182,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-7-3",
    cx: 21.674,
    cy: -47.138,
    r: 0.966,
    transform: "rotate(114.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0748182,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-7-2",
    cx: -77.303,
    cy: 36.655,
    r: 0.966,
    transform: "rotate(-110.065)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0748182,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-7-0",
    cx: 57.969,
    cy: 39.094,
    r: 0.966,
    transform: "rotate(-11.935)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0997578,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-2-95",
    cx: -3.11,
    cy: 60.545,
    r: 1.288,
    transform: "rotate(-57.786)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.0997578,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-2-9",
    cx: -27.932,
    cy: 68.875,
    r: 1.288,
    transform: "rotate(-77.071)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 0.149636,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3795-2-7",
    cx: -35.468,
    cy: 56.961,
    r: 1.932,
    transform: "rotate(-83.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1077",
    transform: "translate(-19.05 -3.704)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "mix",
    id: "text12726-4",
    style: {
      fontStyle: "italic",
      fontSize: "50.8px",
      lineHeight: 0,
      fontFamily: "'Lato Bold Italic'",
      InkscapeFontSpecification: "'Lato Bold Italic'",
      letterSpacing: "-1.51871px",
      fillOpacity: 0,
      stroke: "#000",
      strokeWidth: 0.666001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.54 64.248 3.15-26.086h3.2q.99 0 1.524.483.559.482.559 1.55l-.127 2.87q1.752-2.668 3.81-3.963 2.057-1.32 4.292-1.32 2.388 0 3.785 1.6 1.397 1.6 1.625 4.622 1.83-3.2 4.039-4.699 2.235-1.524 4.851-1.524 1.651 0 2.896.66 1.245.661 2.032 1.931.787 1.245 1.067 3.099.28 1.829-.026 4.19l-1.955 16.587h-6.198l1.956-16.586q.33-2.54-.153-3.632-.457-1.118-1.88-1.118-.964 0-1.879.508-.914.508-1.752 1.473-.813.965-1.524 2.362-.686 1.397-1.22 3.15l-1.625 13.843h-6.198l1.981-16.586q.305-2.54-.127-3.632-.431-1.118-1.88-1.118-1.015 0-1.955.533-.914.534-1.753 1.55-.812.99-1.524 2.438-.685 1.423-1.219 3.2l-1.625 13.615z",
    style: {
      fontWeight: 700,
      fontFamily: "Lato",
      fillOpacity: 1,
      strokeWidth: 0.666,
      strokeOpacity: 0
    },
    id: "path1125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.856 38.188-3.124 26.06h-6.173l3.125-26.06zm1.6-7.595q0 .813-.356 1.524-.33.711-.889 1.245-.558.533-1.27.863-.71.305-1.473.305-.736 0-1.422-.305-.686-.33-1.22-.863-.533-.534-.863-1.245-.305-.711-.305-1.524 0-.813.33-1.55.33-.736.864-1.27.533-.558 1.22-.863.71-.33 1.447-.33.762 0 1.473.33.711.305 1.245.838.559.534.889 1.27.33.737.33 1.575z",
    style: {
      fontWeight: 700,
      fontFamily: "Lato",
      fillOpacity: 1,
      strokeWidth: 0.666,
      strokeOpacity: 0
    },
    id: "path1127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.397 50.176 6.68 14.072h-5.69q-.635 0-1.016-.33-.355-.356-.559-.813l-4.013-9.17q-.127.305-.28.585-.126.254-.304.508l-5.791 8.077q-.33.432-.737.787-.38.356-.99.356h-5.512l10.338-14.072-6.02-11.988h5.69q.634 0 .914.177.28.178.482.61l3.556 7.747q.153-.305.33-.61.178-.304.407-.635l4.597-6.4q.56-.89 1.372-.89h5.69z",
    style: {
      fontWeight: 700,
      fontFamily: "Lato",
      fillOpacity: 1,
      strokeWidth: 0.666,
      strokeOpacity: 0
    },
    id: "path1129"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      strokeWidth: 2.064,
      strokeOpacity: 0.827451
    },
    id: "path2785",
    cx: 129.56,
    cy: 30.564,
    r: 3.99
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2003",
    transform: "translate(-35.398 -4.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#920092",
      fillOpacity: 1,
      stroke: "#920092",
      strokeWidth: 1.565,
      strokeOpacity: 1
    },
    id: "path621",
    d: "m172.201 78.216-1.256 1.992-1.097-2.084z",
    transform: "matrix(1.3957 -.0331 .03526 .84676 -70.122 -21)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "fi",
    id: "text12726",
    style: {
      fontStyle: "italic",
      fontSize: "50.8px",
      lineHeight: 0,
      fontFamily: "'Lato Bold Italic'",
      InkscapeFontSpecification: "'Lato Bold Italic'",
      fill: "#920092",
      stroke: "#000",
      strokeWidth: 0.666001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.643 38.896h14.986l-3.15 25.831h-6.147l2.617-21.361h-8.636l-2.464 20.32-1.296 4.775q-.38 1.22-1.117 1.905-.737.686-2.108.686h-2.515l3.404-27.66-1.93-.356q-.687-.153-1.068-.483-.38-.355-.304-1.016l.279-2.641h3.581l.102-.839q.28-2.387 1.245-4.394.99-2.032 2.667-3.505 1.676-1.499 4.064-2.337 2.387-.838 5.511-.838.991 0 2.083.127 1.118.102 1.854.356l-.61 3.124q-.126.584-.71.686-.585.076-1.397.076-2.286 0-3.887.432-1.6.406-2.641 1.27-1.016.838-1.575 2.133-.559 1.27-.762 2.997z",
    style: {
      fontWeight: 700,
      fontFamily: "Lato",
      strokeWidth: 0.666,
      strokeOpacity: 0
    },
    id: "path1122"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixfiFullLogoLightPathsMin);
export default __webpack_public_path__ + "static/media/mixfi-full-logo-light-paths-min.d1fbdbb3fd723351a503bd7659e03861.svg";
export { ForwardRef as ReactComponent };